import { useEffect, useState } from "react";
import { merge } from "lodash";
import { OrderValue, SOR, WhereItems } from "../../../../globalTypes";
import { handleOrder } from "../../../../utils/sorUtils";
import { RowKey } from "../../../../requests/table/types";

const createSORfromFilter = (filter: WhereItems, rowKey?: RowKey): SOR => ({
  order: {},
  relatedTemplateRowKey: rowKey,
  search: filter,
});

const fillSORwithDefault = (sor: SOR, defaultSor: SOR | undefined): SOR => ({
  order: merge(defaultSor?.order || {}, sor.order),
  relatedTemplateRowKey:
    defaultSor?.relatedTemplateRowKey || sor.relatedTemplateRowKey,
  search: merge(defaultSor?.search || [], sor.search),
});

const useRelationQueryObject = (
  filter: WhereItems,
  rowKey?: RowKey,
  defaultSOR?: SOR | undefined
) => {
  const fillWithDefaultsHelper = () =>
    fillSORwithDefault(createSORfromFilter(filter, rowKey), defaultSOR);
  const [sor, setSor] = useState(fillWithDefaultsHelper);

  // Is here because initial defaultSOR comes empty
  useEffect(() => {
    setSor(fillWithDefaultsHelper());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultSOR]);

  function onOrder(colKey: string, newOrder: OrderValue) {
    const newSor = handleOrder(sor, colKey, newOrder);
    setSor(newSor);
  }

  return { sor, onOrder };
};

export default useRelationQueryObject;
